module.exports = __webpack_public_path__ + "img/orange_039.68ec74f1.png";